import { useState } from 'react';
import { USER_CREATABLE_ORG_TYPES, type CreateOrgInput, type OrgType } from '@ready/shared';
import { ORG_TYPE_LABELS } from '@/lib/labels';
import { Button, ErrorText, Field, Input, Select } from './ui';

export function OrgForm({
  idPrefix,
  submitLabel,
  defaultType = 'university',
  pending,
  error,
  onSubmit,
}: {
  idPrefix: string;
  submitLabel: string;
  defaultType?: OrgType;
  pending: boolean;
  error: unknown;
  onSubmit: (input: CreateOrgInput) => void;
}) {
  const [name, setName] = useState('');
  const [type, setType] = useState<string>(defaultType);
  const [country, setCountry] = useState('IN');

  return (
    <form
      className="grid gap-4 sm:grid-cols-[1fr_12rem_6rem_auto] sm:items-end"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({ name, type, country } as CreateOrgInput);
      }}
    >
      <Field label="Name" htmlFor={`${idPrefix}-name`}>
        <Input
          id={`${idPrefix}-name`}
          required
          minLength={2}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Field>
      <Field label="Type" htmlFor={`${idPrefix}-type`}>
        <Select id={`${idPrefix}-type`} value={type} onChange={(e) => setType(e.target.value)}>
          {USER_CREATABLE_ORG_TYPES.map((t) => (
            <option key={t} value={t}>
              {ORG_TYPE_LABELS[t]}
            </option>
          ))}
        </Select>
      </Field>
      <Field label="Country" htmlFor={`${idPrefix}-country`}>
        <Input
          id={`${idPrefix}-country`}
          required
          maxLength={2}
          value={country}
          onChange={(e) => setCountry(e.target.value.toUpperCase())}
        />
      </Field>
      <Button type="submit" disabled={pending}>
        {submitLabel}
      </Button>
      <div className="sm:col-span-4">
        <ErrorText error={error} />
      </div>
    </form>
  );
}
